module.exports = __webpack_public_path__ + "static/img/2_2_4.67d3d02e.jpg";